import React from "react";
import { Card, Typography } from "antd";

const { Text } = Typography;

const QR = () => {
  return (
    <div
      style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
      <Card
        style={{
          textAlign: "center",
          maxWidth: "300px",
          backgroundColor: "#e6f4ff",
        }}>
        <img
          src="/images/qr.jpeg"
          alt="QR Code"
          style={{ width: "200px", marginBottom: "12px" }}
        />

        <Typography>
          Free. No Ads. Built for students. <br />
          If this saved you time, scan to support this project.
        </Typography>
      </Card>
    </div>
  );
};

export default QR;
